<template>
  <div>
    <div class="w-100 d-inline-block bg-book-banner-image">
      <div class="container autoContent">
        <div class="row margin-top-3 margin-bottom-3">
          <div class="col-12">
            <div class="w-50 d-block text-center m-auto booking-banner position-relative w-xs-100 w-sm-100 w-md-100 w-ipad-100">
              <h1 class="text-black fw-bold text-full-24 family-grand-stander margin-bottom-2 margin-top-2 text-size-24" data-bs-toggle="modal" data-bs-target="#AddressDetailModal">
                Blog
              </h1>
              <p class="text-full-12 text-size-12 text-black family-inter-light mb-0">
                <img class="calendar-icon" src="@/assets/images/blog-clock.svg" alt="picture">    
                Last Updated On <template v-if="blog">{{ formatDateDay(blog.published_at) }}</template>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="blog" class="container-fluid">
      <div class="row margin-top-3 margin-bottom-3">
        <div class="col-xl-9 col-12 col-sm-8 col-md-8 
          col-lg-8">
          <div class="w-100 d-inline-block bg-introduction padding-3 rounded-4 padding-bottom-2">
            <div class="row">
              <div class="col-12 margin-bottom-2">
                <div class="w-100 d-inline-block blog-card padding-3 bg-white rounded-4 blog-detail-card">
                  <div class="card w-100 d-inline-block position-relative border-0">
                      <img class="w-100 rounded-3" 
                          v-lazy="$getImageUrl(blog.featured_image)" 
                          alt="picture" 
                        />
                    <a class="text-white text-size-12 text-full-12 bg-blue position-absolute rounded-3 family-inter-bold fw-bold pets-btn-3" href="javascript:void(0)">
                    {{ blog.category?.name }}
                    </a>
                  </div>
                  <div class="w-100 d-inline-block margin-top-3">
                    <h1 class="card-title text-full-20 text-size-20 text-black family-inter-light fw-bold mb-0">
                      {{ blog.title }}
                    </h1>
                  </div>
                  <div class="w-100 d-inline-block margin-top-1 margin-bottom-1">
                    <a href="javascript:void(0)" class="text-green text-full-12 text-size-12 me-2">
                    <img class="calendar-icon" src="@/assets/images/calendar-blog.svg" alt="picture">
                    {{ formatDate(blog?.published_at) }}
                    </a>
                    <a class="nav-color me-2" href="javascript:void(0)">
                    <i aria-hidden="true" class="fa fa-facebook"></i>
                    </a>
                    <a class="nav-color me-2" href="javascript:void(0)">
                    <img class="calendar-icon" src="@/assets/images/x-icon.svg" alt="picture">
                    </a>
                    <a class="nav-color me-2" href="javascript:void(0)">
                    <i class="fa fa-linkedin" aria-hidden="true"></i>
                    </a>
                  </div>
                  <div class="w-100 d-inline-block blog-detail-introduction">
                    <template v-if="blog && blog.content">
                      <div v-if="showServicesInContent">
                        <div v-html="splitBlogContent.before"></div>
                        <div class="blog-detail-services-section w-100 d-inline-block bg-gallery">
                          <div class="container autoContent">
                            <div class="row">
                              <div class="col-12">
                                <div class="w-100 d-inline-block gallery-slider about-slider blog-detail-gallery-slider position-relative">
                                  <div class="carousel-container">
                                    <transition-group class="carousel" tag="div">
                                      <div v-for="plan in planDetailPrices" :key="plan.id" class="slide">
                                        <div class="card w-100 d-inline-block border-0 rounded-4 position-relative">
                                          <img class="slide-image w-100" v-lazy="$getImageUrl(plan.image)" :alt="plan.name">
                                          <a
                                            v-if="isCustomServicePlan(plan)"
                                            href="javascript:void(0)"
                                            class="blog-service-custom-badge text-white text-size-11 text-full-11 bg-green position-absolute rounded-3 family-inter-bold fw-bold"
                                          >
                                            Custom
                                          </a>
                                          <div class="card-body">
                                            <h3 class="card-title text-size-14 inter-bold-family overflow-hidden margin-bottom-2 text-full-14">
                                              {{ plan.name }}
                                            </h3>
                                            <p class="card-text text-black text-size-14 inter-regular-family overflow-hidden margin-bottom-2 text-full-13">
                                              {{ plan.description }}
                                            </p>
                                            <a
                                              href="javascript:void(0)"
                                              class="nav-color rounded-5 text-uppercase text-size-13 d-inline-block medium-family border-blue me-xl-2 me-3 book-service-btn text-full-13"
                                              @click="addToCart(plan)"
                                            >
                                              Book Service
                                            </a>
                                            <span class="text-size-16 nav-color fw-bold family-grand-stander d-inline-block mt-xl-0 mt-2 mt-lg-0 mt-md-0 text-full-16">
                                              {{ plan.unit || 'AED' }} {{ plan.price }}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </transition-group>
                                    <div class="carousel-controls">
                                      <a href="javascript:void(0)" class="carousel-prev-btn position-absolute" @click="previousPlanSlide">
                                        <img class="position-absolute" src="@/assets/images/prev-left-icon.svg" alt="picture" />
                                      </a>
                                      <a href="javascript:void(0)" class="carousel-next-btn position-absolute" @click="nextPlanSlide">
                                        <img class="position-absolute" src="@/assets/images/next-right-icon.svg" alt="picture" />
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-html="splitBlogContent.after"></div>
                      </div>
                      <div v-else v-html="blog.content"></div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-12 col-sm-4 col-md-4 
          col-lg-4 mt-xl-0 mt-3 mt-md-0">
          <div class="w-100 d-inline-block bg-green bg-recent-post margin-top-2">
            <p class="text-white text-size-13 family-inter-light text-full-13 fw-bold mb-0 padding-top-2 padding-bottom-2 padding-left-3 padding-right-3">Recent Post</p>
          </div>
          <div class="w-100 d-inline-block bg-introduction padding-3 padding-top-2 recent-service-bg">
            <div v-for="latestBlog in latestBlogs" :key="latestBlog.id" class="w-100 d-inline-block blog-card padding-2 bg-white rounded-4 margin-top-2">
              <div class="card w-100 d-inline-block position-relative border-0">
                <!-- <img class="w-100 rounded-3" src="@/assets/images/blog-image-9.png" alt="picture"> -->
                 <img class="w-100 rounded-3" 
                    v-lazy="$getImageUrl(latestBlog.featured_image)" 
                    alt="picture" 
                  />
                <a class="text-white text-size-12 text-full-12 bg-blue position-absolute rounded-3 family-inter-bold fw-bold pets-btn-2" href="javascript:void(0)">
                {{ latestBlog.category?.name || 'Uncategorized' }}
                </a>
                <div class="card-body padding-2 pb-0">
                  <h5 class="card-title text-full-13 text-size-13 text-black family-inter-light fw-bold mb-0">
                    {{ latestBlog.title }}
                  </h5>
                  <a href="javascript:void(0)" class="text-green text-full-12 text-size-12">
                  <img class="calendar-icon" src="@/assets/images/calendar-blog.svg" alt="picture">
                   {{ formatDate(latestBlog.published_at) }}
                  </a>
                  <p class="card-text text-full-12 text-size-12 text-black family-inter-light mb-0">
                    {{ stripHtml(latestBlog.content).slice(0, 200) }}...
                  </p>
                  <a href="javascript:void(0)" class="btn bg-blue margin-top-2 text-white text-size-12 text-full-12 px-3 py-1 rounded-2">
                    See More
                  </a>
                  <router-link :to="`/blog/${latestBlog.slug}`" class="circle-anchor position-absolute">
                  </router-link>
                </div>
              </div>
            </div>
            <!-- <div class="w-100 d-inline-block blog-card padding-2 bg-white rounded-4 margin-top-3">
              <div class="card w-100 d-inline-block position-relative border-0">
                <img class="w-100 rounded-3" src="@/assets/images/blog-image-10.png" alt="picture">
                <a class="text-white text-size-12 text-full-12 bg-blue position-absolute rounded-3 family-inter-bold fw-bold pets-btn-2" href="javascript:void(0)">
                Dog, Pets
                </a>
                <div class="card-body padding-2 pb-0">
                  <h5 class="card-title text-full-13 text-size-13 text-black family-inter-light fw-bold mb-0">How Do Dogs Get Heartworms?</h5>
                  <a href="javascript:void(0)" class="text-green text-full-12 text-size-12">
                  <img class="calendar-icon" src="@/assets/images/calendar-blog.svg" alt="picture">
                  20 March, 2024
                  </a>
                  <p class="card-text text-full-12 text-size-12 text-black family-inter-light">Our four-legged companions hold a special place in our hearts, providing unconditional love and companionship. However, like humans, dogs are susceptible to various health concerns</p>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block 
      bg-introduction">
      <div class="container autoContent">
        <div class="row margin-top-2 margin-bottom-2">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0 margin-top-1">
              <li class="float-start margin-right-2">
                <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
                <i class="fa fa-home nav-color" aria-hidden="true"></i>
                Home  /
                </a>
              </li>
              <li class="float-start">
                <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
                Services
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'blogDetailBannerComponent',
    data() {
      return {
        blog: null,
        latestBlogs: [],
        planDetailPrices: [],
      };
    },
    computed: {
      serviceMeta() {
        return this.resolveServiceMetaFromBlogCategory(this.blog?.category);
      },
      serviceSectionCopy() {
        const meta = this.serviceMeta;
        if (meta) {
          return {
            heading: meta.heading,
            description: meta.description,
          };
        }
        const name = this.blog?.category?.name;
        if (name) {
          return {
            heading: `${name} Services We Offer`,
            description:
              'Explore every grooming package we offer for this category—standard and custom options—and book the service that suits your pet.',
          };
        }
        return { heading: '', description: '' };
      },
      splitBlogContent() {
        return this.splitHtmlAtMiddle(this.blog?.content || '');
      },
      showServicesInContent() {
        return this.planDetailPrices.length > 0;
      },
    },
    mounted() {
      this.getSingleBlog();
    },
    watch: {
      '$route.params.slug'() {
        this.getSingleBlog();
      },
    },
    methods: {
      resolveServiceMetaFromBlogCategory(category) {
        if (!category || !category.name) {
          return null;
        }
        const n = category.name.trim().toLowerCase();
        const tiers = [
          {
            category_name: 'Dog Grooming',
            heading: 'Mobile Dog Grooming Services We Offer',
            description:
              "Whether you're looking for basic dog grooming or a full pampering experience for your lovely dog, we are here to help you. We as a Mobile Dog Grooming Service provider, offer quality services with experienced staff that treat your pet with extra care.",
            test: (s) => s === 'dog grooming' || s.includes('dog'),
          },
          {
            category_name: 'Cat Grooming',
            heading: 'Mobile Cat Grooming Services We Offer',
            description:
              'Whether you want basic cat grooming or a complete pampering experience, Dubai Pet Groomers has best option for every pet and budget, and we are here to provide you high-quality mobile cat grooming services at a reasonable price.',
            test: (s) => s === 'cat grooming' || s.includes('cat'),
          },
          {
            category_name: 'Birds Grooming',
            heading: 'Mobile Birds Grooming Services We Offer',
            description:
              "Grooming is a vital step in keeping your birds healthy since parasites and dust can cause diseases; thus, frequent grooming is necessary. Our customized mobile grooming services cater to your bird's specific needs, and expert pet groomers will provide you with excellent and economical bird grooming services in a comfortable or relaxed setting.",
            test: (s) => s === 'birds grooming' || s === 'bird grooming' || s.includes('bird'),
          },
          {
            category_name: 'Rabbit Grooming',
            heading: 'Mobile Rabbit Grooming Services We Provide',
            description:
              "Dubai Pet Groomer is pleased to build the most creative, advanced, pet-friendly, and cost-effective mobile rabbit grooming facilities. It offers a variety of services to meet your pet's essential requirements.",
            test: (s) => s === 'rabbit grooming' || s.includes('rabbit'),
          },
        ];
        for (const tier of tiers) {
          if (tier.test(n)) {
            return {
              category_name: tier.category_name,
              heading: tier.heading,
              description: tier.description,
            };
          }
        }
        return null;
      },
      resolveServicePageCategoryName(blogCategory, categories, categoryId) {
        const meta = this.serviceMeta || this.resolveServiceMetaFromBlogCategory(blogCategory);
        if (meta && meta.category_name) {
          return meta.category_name;
        }
        if (categoryId != null && Array.isArray(categories)) {
          const cat = categories.find((c) => Number(c.id) === Number(categoryId));
          if (cat && cat.name) {
            return cat.name;
          }
        }
        return null;
      },
      async fetchServicePagePlanPrices(categoryName, categoryId) {
        const res = await this.$axios.post('/get-service-categories', {
          website_name: this.$websiteName,
          category_name: categoryName,
          include_custom_plan_prices: true,
        });
        if (res.data.status !== 'success') {
          return [];
        }
        const legacyData = res.data;
        const legacyMain = Array.isArray(legacyData.planDetailPrices)
          ? legacyData.planDetailPrices
          : [];
        const legacyCustom = this.collectRootCustomPriceLists(legacyData, categoryId);
        return this.mergePlanDetailPricesById([legacyMain, legacyCustom]);
      },
      splitHtmlAtMiddle(html) {
        if (!html) {
          return { before: '', after: '' };
        }
        let matches = [...html.matchAll(/<\/p>/gi)];
        if (matches.length === 0) {
          matches = [...html.matchAll(/<br\s*\/?>/gi)];
        }
        if (matches.length === 0) {
          return { before: html, after: '' };
        }
        const midIndex = Math.floor(matches.length / 2);
        const splitPos = matches[midIndex].index + matches[midIndex][0].length;
        return {
          before: html.slice(0, splitPos),
          after: html.slice(splitPos),
        };
      },
      resolveBookingCategoryId(blogCategory, categories) {
        if (!blogCategory || !Array.isArray(categories)) {
          return null;
        }
        if (categories.some((c) => c.id === blogCategory.id)) {
          return blogCategory.id;
        }
        const blogName = (blogCategory.name || '').trim().toLowerCase();
        const byName = categories.find(
          (c) => c.name && c.name.trim().toLowerCase() === blogName,
        );
        if (byName) {
          return byName.id;
        }
        const meta = this.resolveServiceMetaFromBlogCategory(blogCategory);
        if (meta) {
          const mn = meta.category_name.trim().toLowerCase();
          const metaMatch = categories.find(
            (c) => c.name && c.name.trim().toLowerCase() === mn,
          );
          if (metaMatch) {
            return metaMatch.id;
          }
        }
        return null;
      },
      isCustomServicePlan(plan) {
        if (!plan) {
          return false;
        }
        if (plan.is_custom !== undefined && plan.is_custom !== null) {
          return Number(plan.is_custom) === 1;
        }
        const raw =
          plan.is_custom_service ??
          plan.custom_service ??
          plan.is_custom_plan;
        if (raw === true || raw === 1 || raw === '1') {
          return true;
        }
        const t = plan.service_type;
        return typeof t === 'string' && t.toLowerCase() === 'custom';
      },
      mergePlanDetailPricesById(priceLists) {
        const seen = new Set();
        const result = [];
        for (const list of priceLists) {
          if (!Array.isArray(list)) {
            continue;
          }
          for (const p of list) {
            if (p && p.id != null && !seen.has(p.id)) {
              seen.add(p.id);
              result.push(p);
            }
          }
        }
        return result;
      },
      filterPricesByCategoryId(prices, categoryId) {
        if (!Array.isArray(prices)) {
          return [];
        }
        if (categoryId == null) {
          return prices;
        }
        return prices.filter((p) => {
          if (!p) {
            return false;
          }
          if (p.category_id == null) {
            return true;
          }
          return Number(p.category_id) === Number(categoryId);
        });
      },
      collectRootCustomPriceLists(data, categoryId) {
        const keys = [
          'customPlanDetailPrices',
          'custom_plan_detail_prices',
          'planDetailPricesCustom',
          'custom_plan_prices',
        ];
        const chunks = [];
        for (const k of keys) {
          chunks.push(this.filterPricesByCategoryId(data[k], categoryId));
        }
        return this.mergePlanDetailPricesById(chunks);
      },
      combinedPlanDetailGroups(data) {
        return [
          ...(data.planDetails || []),
          ...(data.customPlanDetails || []),
          ...(data.custom_plan_details || []),
        ];
      },
      priceRowMatchesBlogCategory(price, group, categoryId) {
        if (categoryId == null || !price) {
          return false;
        }
        const cid = Number(categoryId);
        if (price.category_id != null && price.category_id !== '') {
          return Number(price.category_id) === cid;
        }
        if (group && group.category_id != null && group.category_id !== '') {
          return Number(group.category_id) === cid;
        }
        return false;
      },
      collectPlanDetailPricesForCategory(planDetails, categoryId) {
        if (categoryId == null || !Array.isArray(planDetails)) {
          return [];
        }
        const prices = [];
        const seen = new Set();
        for (const g of planDetails) {
          const arrays = [
            g.plan_detail_prices,
            g.custom_plan_detail_prices,
            g.plan_detail_prices_custom,
          ];
          for (const arr of arrays) {
            if (!Array.isArray(arr)) {
              continue;
            }
            for (const price of arr) {
              if (!price || price.id == null || seen.has(price.id)) {
                continue;
              }
              if (!this.priceRowMatchesBlogCategory(price, g, categoryId)) {
                continue;
              }
              seen.add(price.id);
              prices.push(price);
            }
          }
        }
        return prices;
      },
      async fetchServicesForBlogCategory() {
        const blogCategory = this.blog?.category;
        if (!blogCategory) {
          this.planDetailPrices = [];
          return;
        }
        try {
          let categories = [];
          let categoryId = null;
          let prices = [];

          const response = await this.$axios.post('/get-categories', {
            website_name: this.$websiteName,
            include_custom_plan_prices: true,
          });
          if (response.data.status === 'success') {
            const data = response.data;
            categories = data.categories || [];
            categoryId = this.resolveBookingCategoryId(blogCategory, categories);
            const planDetailGroups = this.combinedPlanDetailGroups(data);
            const fromGroups = this.collectPlanDetailPricesForCategory(planDetailGroups, categoryId);
            const fromRootCustom = this.collectRootCustomPriceLists(data, categoryId);
            prices = this.mergePlanDetailPricesById([fromGroups, fromRootCustom]);
          }

          const serviceCategoryName = this.resolveServicePageCategoryName(
            blogCategory,
            categories,
            categoryId,
          );
          if (serviceCategoryName) {
            try {
              const fromServicePage = await this.fetchServicePagePlanPrices(
                serviceCategoryName,
                categoryId,
              );
              prices = this.mergePlanDetailPricesById([prices, fromServicePage]);
            } catch (svcErr) {
              console.error('Could not merge service-page plans:', svcErr.response || svcErr.message);
            }
          }

          this.planDetailPrices = prices;
        } catch (error) {
          console.error('Error fetching blog-related services:', error.response || error.message);
          this.planDetailPrices = [];
        }
      },
      addToCart(service) {
        const cartData = localStorage.getItem('cart');
        let cart = cartData ? JSON.parse(cartData) : [];
        const serviceExists = cart.find((item) => item.id === service.id);
        if (serviceExists) {
          serviceExists.count++;
        } else {
          cart.push({ ...service, count: 1 });
        }
        localStorage.setItem('cart', JSON.stringify(cart));
        this.$router.push('/booking/');
      },
      previousPlanSlide() {
        if (!this.planDetailPrices.length) {
          return;
        }
        const last = this.planDetailPrices.pop();
        this.planDetailPrices = [last].concat(this.planDetailPrices);
      },
      nextPlanSlide() {
        if (!this.planDetailPrices.length) {
          return;
        }
        const first = this.planDetailPrices.shift();
        this.planDetailPrices = this.planDetailPrices.concat(first);
      },
      async getSingleBlog() {
        try {
          const slug = this.$route.params.slug;
          const response = await this.$axios.post('/get-blog-detail', {
            website_name: this.$websiteName,
            slug,
          });
          if (response.data.status === 'success') {
            this.blog = response.data.blog;
            this.latestBlogs = response.data.latest_blogs || [];
            this.applyBlogSeo();
            this.planDetailPrices = [];
            await this.fetchServicesForBlogCategory();
          } else {
            console.error('Failed to fetch blogs:', response.data);
          }
        } catch (error) {
          console.error('Error fetching blogs:', error);
        }
      },
      ensureMetaTag(name) {
        let tag = document.querySelector(`meta[name="${name}"]`);
        if (!tag) {
          tag = document.createElement('meta');
          tag.setAttribute('name', name);
          document.head.appendChild(tag);
        }
        return tag;
      },
      applyBlogSeo() {
        if (!this.blog) {
          return;
        }
        const title = (this.blog.meta_title || this.blog.title || '').trim();
        if (title) {
          document.title = title;
        }

        const metaDescRaw =
          (this.blog.meta_description || '').trim() ||
          this.stripHtml(this.blog.content || '').trim().slice(0, 160);
        if (metaDescRaw) {
          const tag = this.ensureMetaTag('description');
          tag.setAttribute('content', metaDescRaw);
        }
      },
      stripHtml(html) {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
      },
      formatDate(dateString) {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-GB', {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
        }).format(date);
      },
      formatDateDay(dateString) {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-GB', {
          weekday: 'long',
          day: '2-digit',
          month: 'long',
          year: 'numeric',
        }).format(date);
      },
    },
  };
</script>
<style scoped>
.blog-detail-services-section {
  width: 100vw;
  max-width: 100vw;
  margin-right: calc(50% - 50vw);
}

/* Show three slides at once on the blog detail carousel (global .gallery-slider uses 25% = four). */
.blog-detail-gallery-slider.gallery-slider .slide {
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}

@media (max-width: 991px) {
  .blog-detail-gallery-slider.gallery-slider .slide {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (max-width: 567px) {
  .blog-detail-gallery-slider.gallery-slider .slide {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.blog-service-custom-badge {
  top: 0.6rem;
  right: 0.6rem;
  left: auto;
  padding: 0.25rem 0.5rem;
  z-index: 1;
}
</style>